module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre_17",
    attrs: {
      "id": "filepos57248"
    }
  }, [_c('span', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "italic1"
  }, [_c('a', {
    staticClass: "calibre8"
  }), _vm._v("Prolegomenon")])])]), _c('div', {
    staticClass: "calibre_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre_18"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("The normal occidental, brought up in quasi-absolute materialism, whose religion—in so far as he has any—is dualistic (which comports the opposition of spirit and matter, of God and man), usually believes that nothing exists except that which his senses can perceive, i.e. in a universe confined within the limitations of his sensorial apparatus. Such a man cannot possibly comprehend that reality expounded by the Sages, without a complete reversal of all his beliefs, a total revaluation of all his values.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Such a transformation is only possible to a few, and it cannot reasonably occur within a period less than a considerable number of years. Even so it requires a powerful urge from the plane of reality, which few experience, and an intellectual apparatus of an order that is sparsely distributed in any society.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Moreover, no organised system of re-education to that end exists in the West, and years are apt to pass before such a man even begins to realise that what he believes to be reality is phenomenal, and that what he believes to be phenomenal may be Reality.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("And by then he has found out that the phenomenal universe appears to exist precisely because his sensorial apparatus has interpreted reality in that form, and is in fact a product of mind.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("And that is not where the journey ends, but the terminus from which the traveller sets forth, for, in order that intuition "), _c('a'), _vm._v("may penetrate effectively, it needs a mind that is conditioned to interpret it.")])]), _vm._v(" "), _c('div', {
    staticClass: "mbp_pagebreak",
    attrs: {
      "id": "calibre_pb_14"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f589d85e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_009.vue
// module id = 87
// module chunks = 0